export interface CustomerReferential {
  CasingCredit: Referential[];
  CasingPurchase: Referential[];
  PreferredTreadSpec: Referential[];
  CasingGradeTable: Referential[];
  FreeRepairTable: Referential[];
  DisposalCharge: Referential[];
  PrintingTemplate: Referential[];
  RememberBrand: Referential[];
  RememberCasingNote: Referential[];
}

export interface Referential {
  id: string;
  code: string;
  description: string;
}

export function emptyCustomerReferential(): CustomerReferential {
  return {
    CasingCredit: [],
    CasingPurchase: [],
    PreferredTreadSpec: [],
    CasingGradeTable: [],
    FreeRepairTable: [],
    DisposalCharge: [],
    PrintingTemplate: [],
    RememberBrand: [],
    RememberCasingNote: []
  };
}

export function getCustomerStockAllReferential(): Referential[] {
  return [
    {
      id: 'C',
      code: 'Customer',
      description: 'Customer'
    },
    {
      id: 'S',
      code: 'Stock',
      description: 'Stock'
    },
    {
      id: 'A',
      code: 'All',
      description: 'All'
    }
  ];
}
